module.exports = __webpack_public_path__ + "./images/2269bf328043336118da34d43a415d39.webp";